import React,{ PureComponent } from 'react'

// import "video-react/dist/video-react.css";
// import { Player, BigPlayButton } from 'video-react';


export default class Videoplayer extends PureComponent {

    is_playing = false;

    componentDidMount() {
        // this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this));
        var vid = document.getElementById("video_player");
        vid.onplaying = () => {
            if(!this.is_playing){
                this.is_playing = true
                if(this.props.handleTimer)
                setTimeout(() => this.props.handleTimer(10), 2000);
            }
        };
    }

    // handleStateChange = (state) => this.props.handleTimer((state.currentTime | 0))

    render(){
        const { handleTimer, ...others} = this.props
        
        return (
            <video 
                preload="auto"
                id="video_player"
                {...others}
                playsInline
                tabIndex="-1" 
                height="200"
                style={{ objectFit: "fill" }}
                controls
            >
                Your browser does not support the video tag.
            </video>
        )

        // return (
        //     <Player
        //         playsInline
        //         {...this.props}
        //         ref="player"
        //         // poster="https://is1-ssl.mzstatic.com/image/thumb/Purple71/v4/15/c0/34/15c0344f-9230-3cfe-3238-1cbafb410aaa/pr_source.jpg/643x0w.jpg"
        //         // src={MAKEURL(item.video_url)}
        //         // key={item.id}
        //     >
        //         <BigPlayButton position="center" />
        //     </Player>
        // )
    }
}